import * as Sentry from '@sentry/tanstackstart-react';

type MediaErrorContext = {
  scope: 'voiceRoom' | 'callRoom' | 'micLevel';
  operation: string;
  sessionId?: string;
  callId?: string;
  connectionState?: string;
  requestedEnabled?: boolean;
  deviceKind?: string;
  borrowedTrack?: boolean;
  microphoneEnabled?: boolean;
  microphoneTrackState?: string;
  microphoneTrackMuted?: boolean;
};

/** One reporter per hook: focus/visibility retries must not flood the same failure. */
export const createMediaErrorReporter = () => {
  const recent = new Map<string, number>();

  return (error: unknown, context: MediaErrorContext) => {
    const name = error instanceof Error ? error.name : 'UnknownError';
    const message = error instanceof Error ? error.message : String(error);
    const key = JSON.stringify([
      context.scope,
      context.sessionId,
      context.callId,
      context.operation,
      context.deviceKind,
      context.requestedEnabled,
      name,
      message,
    ]);
    const now = Date.now();
    const last = recent.get(key);
    if (last !== undefined && now - last < 30_000) return;
    if (recent.size >= 64) recent.clear();
    recent.set(key, now);

    Sentry.withScope((scope) => {
      scope.setTag('scope', context.scope);
      scope.setTag('type', 'media-device');
      scope.setTag('operation', context.operation);
      scope.setTag('mediaErrorName', name);
      scope.setLevel('warning');
      // Only explicit diagnostic fields: never include room tokens or device identifiers.
      scope.setContext('media', {
        ...context,
        online: typeof navigator === 'undefined' ? undefined : navigator.onLine,
      });
      Sentry.captureException(error);
    });
  };
};
